import { generateKey } from '@utils';
import Styled from './LineBarChartCard.styled';

interface Row {
  label: string;
  percentage: number;
  index: string;
}

interface Props {
  title: string;
  rows: Row[];
}

function LineBarChartCard({ title, rows }: Props) {
  return (
    <Styled.Root>
      <Styled.Title>{title}</Styled.Title>
      <Styled.Rows>
        {rows.map((row, index) => {
          const percentage = Math.min(100, Math.max(0, row.percentage));

          return (
            <Styled.Row
              key={generateKey(`line-bar-${index}-${row.label}-${percentage}`)}>
              <Styled.Label>{row.label}</Styled.Label>
              <Styled.BarRow>
                <Styled.BarTrack>
                  <Styled.BarFill $percentage={percentage} />
                </Styled.BarTrack>
                <Styled.Values>
                  <Styled.Percentage>{percentage}%</Styled.Percentage>
                  <Styled.Index>{row.index}</Styled.Index>
                </Styled.Values>
              </Styled.BarRow>
            </Styled.Row>
          );
        })}
      </Styled.Rows>
    </Styled.Root>
  );
}

export default LineBarChartCard;
